<template>
  <div>
    <v-text-field
      v-model="formData.tanggal"
      type="date"
      label="Tanggal"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchLaporan"
    ></v-text-field>
    <v-checkbox
      v-model="formData.hanya_selesai"
      label="Hanya tampilkan data yang masuk pelaporan pajak"
      hide-details
      dense
      class="mb-2"
    ></v-checkbox>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="d-flex">
          <h1 class="report-title-light mr-5">
            MAJOR LAPORAN HARIAN CASHIER
          </h1>
          <div style="font-size: 1.5rem;">
            <h2 style="font-weight: normal;">
              {{ formatDate(formData.tanggal) }}
            </h2>
          </div>
        </div>
      </div>

      <div class="body">
        <div class="mt-5">
          <div
            class="w-100 d-flex justify-content-between mb-2"
            style="border-bottom: 1px solid lightgray; padding-bottom: 5px;"
          >
            <h4 class="report-title underline">BIAYA BURUH</h4>

            <h3 class="font-weight-light border">
              Rp. {{ formatCurrency(totalPengeluaranBuruh) }}
            </h3>
          </div>

          <div v-for="(value, name, index) in data.buruh" :key="name">
            <table class="w-100">
              <thead>
                <tr>
                  <th width="15%" class="text-left">Nomor Nota / ID</th>
                  <th width="20%" class="text-left">Dibayar Kepada</th>
                  <th width="30%" class="text-right">Upah Buruh</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in value" :key="index">
                  <td class="text-left">{{ item.nomor_nota }}</td>
                  <td class="text-left">{{ item.nama_penagih }}</td>
                  <td class="text-right">
                    Rp.
                    {{ formatCurrency(Math.abs(item.total)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-5">
          <div
            class="w-100 d-flex justify-content-between mb-2"
            style="border-bottom: 1px solid lightgray; padding-bottom: 5px;"
          >
            <h4 class="report-title underline">BIAYA SURAT JALAN</h4>

            <h3 class="font-weight-light border">
              Rp. {{ formatCurrency(totalPengeluaranTruk) }}
            </h3>
          </div>

          <div v-for="(value, name, index) in data.truk" :key="name">
            <table class="w-100">
              <thead>
                <tr>
                  <th width="15%" class="text-left">NoSJ</th>
                  <th width="10%" class="text-left">NoPol</th>
                  <th width="25%">DaerahAntar</th>
                  <th width="10%" class="text-center">M3</th>
                  <th width="10%" class="text-center">Ton</th>
                  <th width="20%" class="text-right">BiayaSj</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in value" :key="index">
                  <td class="text-left">{{ item.nomor_nota }}</td>
                  <td class="text-left">{{ item.nomor_polisi }}</td>
                  <td class="text-center">{{ item.daerah_antar }}</td>
                  <td class="text-center">
                    {{ countTotalM3(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ countTotalTon(item.invoice_detil) }}
                  </td>
                  <td class="text-right">
                    Rp.
                    {{ formatCurrency(Math.abs(item.total)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-5">
          <div
            class="w-100 d-flex justify-content-between mb-2"
            style="border-bottom: 1px solid lightgray; padding-bottom: 5px;"
          >
            <h4 class="report-title underline">PENGELUARAN LAIN</h4>

            <h3 class="font-weight-light border">
              Rp. {{ formatCurrency(totalLainLain) }}
            </h3>
          </div>

          <div v-for="(value, name, index) in data.lain" :key="name">
            <p style="font-size: 14px; margin-top: 15px;">
              <b>Kategori:</b> {{ name }}
            </p>

            <table class="w-100">
              <thead>
                <tr>
                  <th width="10%" class="text-left">Nomor</th>
                  <th width="15%" class="text-left">Oleh</th>
                  <th width="15%" class="text-left">ACC</th>
                  <th width="30%">Keterangan</th>
                  <th width="20%" class="text-right">Rp</th>
                  <th width="10%">KV</th>
                  <th width="10%">KC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in value" :key="index">
                  <td class="text-left">{{ item.id }}</td>
                  <td class="text-left">{{ item.oleh.nama }}</td>
                  <td class="text-left">{{ item.acc.nama }}</td>
                  <td class="text-center">{{ item.keperluan }}</td>
                  <td class="text-right">
                    Rp.
                    {{ formatCurrency(Math.abs(item.nominal)) }}
                  </td>
                  <td class="text-center">{{ item.kv }}</td>
                  <td class="text-center">{{ item.kc }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      portAwal: JSON.parse(localStorage.getItem("port_awal")),
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal: new Date().toISOString().substr(0, 10),
        hanya_selesai: true
      },
      sisa_cash: 0,
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    totalPendapatan() {
      let total = 0;

      for (const item in this.data.pendapatan) {
        for (const detail of this.data.pendapatan[item]) {
          total += Math.abs(detail.nominal);
        }
      }

      return total;
    },
    totalPengeluaranBuruh() {
      let total = 0;

      for (const item in this.data.buruh) {
        for (const detail of this.data.buruh[item]) {
          total += Math.abs(detail.total);
        }
      }

      return total;
    },
    totalPengeluaranTruk() {
      let total = 0;

      for (const item in this.data.truk) {
        for (const detail of this.data.truk[item]) {
          total += Math.abs(detail.total);
        }
      }

      return total;
    },
    totalLainLain() {
      let total = 0;

      // for (const item in this.data.lain) {
      //   for (const detail of this.data.lain[item]) {
      //     if (detail.jenis === "keluar") {
      //       total += Math.abs(detail.nominal);
      //     } else if (detail.jenis === "masuk") {
      //       total -= Math.abs(detail.nominal);
      //     }
      //   }
      // }

      for (const item in this.data.lain) {
        for (const detail of this.data.lain[item]) {
          total += Math.abs(detail.nominal);
        }
      }

      return total;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(
          `kas/laporan-pengeluaran-keseluruhan?tanggal=${
            this.formData.tanggal
          }&hanya_selesai=${this.formData.hanya_selesai ? 1 : 0}`
        )
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data.data;
            this.sisa_cash = res.data.sisa_cash;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    countTotalKoli(data) {
      let total = 0;

      data.forEach(ttb => {
        ttb.ttb_rinci.forEach(rinci => {
          total += parseFloat(rinci.koli);
        });
      });

      return total;
    },
    countTotalM3(data) {
      let total = 0;

      data.forEach(ttb => {
        ttb.ttb_rinci.forEach(rinci => {
          total += parseFloat(rinci.m3);
        });
      });

      return total.toFixed(2);
    },
    countTotalTon(data) {
      let total = 0;

      data.forEach(ttb => {
        ttb.ttb_rinci.forEach(rinci => {
          total += parseFloat(rinci.ton);
        });
      });

      return total.toFixed(2);
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      if (num < 0) {
        return `(${new Intl.NumberFormat("id-ID").format(Math.abs(num))})`;
      } else {
        return new Intl.NumberFormat("id-ID").format(num);
      }
    }
  },
  mounted() {
    // console.log(localStorage.getItem("port_awal"));
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report-title-light {
  font-weight: 400;
  text-decoration: underline;
}

.border {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 1px solid black;
  line-height: 1;
  padding: 0 5px;
}

.border h2 {
  text-decoration: none;
}

.w-30 {
  width: 30%;
}

.w-40 {
  width: 40%;
}

.justify-content-between {
  justify-content: space-between;
}

th {
  font-weight: bold !important;
}

.underline {
  text-decoration: underline;
}
</style>
